import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, DateTimeInput, DateInput } from 'react-admin';
import {
    useListContext,
    useRedirect,
    List,
    Datagrid,
    Filter,
    Edit,
    Create,

    Toolbar,
    TopToolbar,
    DeleteWithConfirmButton,
    BulkDeleteWithConfirmButton,
    Show,
    SimpleShowLayout,

    ReferenceField,
    TextField,
    ImageField,
    BooleanField,
    RichTextField,
    SelectField,

    SimpleForm,
    ReferenceInput,
    SelectInput,
    TextInput,
    NumberInput,
    BooleanInput,
    NullableBooleanInput,

    Button,
    EditButton,
    ShowButton,
    SaveButton,
} from 'react-admin';
import { Button as CButton, Box } from '@material-ui/core';
import { ArrowBack, Search } from '@material-ui/icons';

const useTxtData = {
    page: {
        tableName: '资源对接申请',
    },
    table: {
        id: 'ID',
        UserId: '申请用户',
        CompanyId: '目标企业',
        Status: '状态',
        ApplyDesc: '申请说明',
        ApplyTime: '申请时间',
        UpdateTime: '更新时间',
    }
};

const statusChoices = [
    { id: 0, name: '待处理' },
    { id: 1, name: '已联系' },
    { id: 2, name: '已签约' },
    { id: 3, name: '不匹配' },
];

export const ResourceApplyList = (props) => {
    const Filters = (props) => {
        const { displayedFilters, filterValues, setFilters, hideFilter, } = useListContext();
        if (props.context === "button") return null;
        const onSubmit = values => { if (Object.keys(values).length > 0) { setFilters(values); } else { setFilters({}, []); } };
        const resetFilter = () => { setFilters({}, []); };
        return (
            <div>
                <Form onSubmit={onSubmit} initialValues={filterValues}>
                    {({ handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Box display='flex' alignItems='center'>
                                <Box component="span" mr={2}>
                                    <ReferenceInput label="申请用户" source="UserId" reference="Admin/CMSUser">
                                        <SelectInput optionText="NickName" />
                                    </ReferenceInput>
                                </Box>
                                <Box component="span" mr={2}>
                                    <ReferenceInput label="目标企业" source="CompanyId" reference="Admin/CMSS_jinyingzhuti">
                                        <SelectInput optionText="ComName" />
                                    </ReferenceInput>
                                </Box>
                                <Box component="span" mr={2}>
                                    <SelectInput label="状态" source="Status" choices={statusChoices} />
                                </Box>
                                <Box component="span" mr={2} mb={2.5}>
                                    <CButton variant="contained" color="primary" type="submit" startIcon={<Search />}>搜索</CButton>
                                </Box>
                                <Box component="span" mr={2} mb={2.5}>
                                    <CButton variant="outlined" onClick={resetFilter}>重置</CButton>
                                </Box>
                            </Box>
                        </form>
                    )}
                </Form>
            </div>
        );
    };

    const AssetBulkActionButtons = (props) => {
        return (
            <Fragment>
                <BulkDeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" />
            </Fragment>
        );
    };

    const RowAction = (props) => {
        return (
            <div style={{ textAlign: 'right' }}>
                <EditButton {...props} /><br />
                <ShowButton {...props} /><br />
                <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" />
            </div>
        );
    }

    return (
        <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<Filters />} bulkActionButtons={<AssetBulkActionButtons />} >
            <Datagrid>
                <TextField label={useTxtData.table.id} source="id" />
                <ReferenceField label={useTxtData.table.UserId} source="UserId" reference="Admin/CMSUser">
                    <TextField source="NickName" />
                </ReferenceField>
                <ReferenceField label={useTxtData.table.CompanyId} source="CompanyId" reference="Admin/CMSS_jinyingzhuti">
                    <TextField source="ComName" />
                </ReferenceField>
                <SelectField label={useTxtData.table.Status} source="Status" choices={statusChoices} />
                {/* Using SelectInput with disabled prop as a quick way to show label, or use SelectField if it exists, assume SelectField exists or use FunctionField */}
                <TextField label={useTxtData.table.ApplyTime} source="ApplyTime" />
                <RowAction />
            </Datagrid>
        </List>
    );
};

export const ResourceApplyShow = (props) => {
    const ShowActions = (props) => {
        const { basePath, data } = props; const redirect = useRedirect();
        return (
            <TopToolbar>
                <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
                    <ArrowBack />
                </Button>
                <EditButton basePath={basePath} record={data} />
            </TopToolbar>
        );
    };

    return (
        <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
            <SimpleShowLayout>
                <TextField label={useTxtData.table.id} source="id" />
                <ReferenceField label={useTxtData.table.UserId} source="UserId" reference="Admin/CMSUser">
                    <TextField source="NickName" />
                </ReferenceField>
                <ReferenceField label={useTxtData.table.CompanyId} source="CompanyId" reference="Admin/CMSS_jinyingzhuti">
                    <TextField source="ComName" />
                </ReferenceField>
                <SelectField label={useTxtData.table.Status} source="Status" choices={statusChoices} />
                <TextField label={useTxtData.table.ApplyDesc} source="ApplyDesc" />
                <TextField label={useTxtData.table.ApplyTime} source="ApplyTime" />
                <TextField label={useTxtData.table.UpdateTime} source="UpdateTime" />
            </SimpleShowLayout>
        </Show>
    );
}

export const ResourceApplyEdit = (props) => {
    const PostEditActions = (props) => {
        const { basePath } = props; const redirect = useRedirect();
        return (
            <TopToolbar {...props}>
                <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
                    <ArrowBack />
                </Button>
            </TopToolbar>
        );
    };
    const PostEditToolbar = (props) => {
        return (
            <Toolbar {...props}>
                <SaveButton />
            </Toolbar>
        );
    };
    return (
        <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostEditActions />}>
            <SimpleForm toolbar={<PostEditToolbar />}>
                <SelectInput label={useTxtData.table.Status} source="Status" choices={statusChoices} />
                <TextField source="ApplyDesc" label={useTxtData.table.ApplyDesc} fullWidth multiline />
            </SimpleForm>
        </Edit>
    );
};
